import { Result, failure, success } from '../shared'
import { PermissionProvider } from './permission.provider'
import { PermissionServiceErrorCode, PermissionsServerData } from './permission.types'

export class PermissionService {
  constructor(private provider: PermissionProvider) {}

  public async get(): Promise<Result<PermissionsServerData>> {
    try {
      const { data } = await this.provider.get()
      return success(data)
    } catch (error) {
      return failure(PermissionServiceErrorCode.GENERAL)
    }
  }
}
